import { Order } from "@/types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mantine/core";
import Accordion from "@/components/organisms/AccordionDrawer";
import Text from "@/components/atoms/Text";
import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";
import { useAuth } from "@/contexts/AuthContext";

interface AccordionGeneralProps {
  order: Order;
}

const AccordionGeneral = ({ order }: AccordionGeneralProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <Accordion
      initiallyOpen
      title={order.orderType.id === OrderTypeEnum.SELL ? t("orders:sellProduct") : t("orders:purchaseProduct")}
    >
      <Grid p={20}>
        <Grid.Col span={3}>
          <Text size="sm" color={"secondary"}>
            {t("product:product")}
          </Text>
        </Grid.Col>
        <Grid.Col span={9}>
          <Text size="sm">
            {order.salesItem.nameTranslated?.[user?.language?.id as number] ?? order.salesItem.salesItem}
          </Text>
        </Grid.Col>
        <Grid.Col span={3}>
          <Text size="sm" color={"secondary"}>
            {t("orders:estimatedAmount")}
          </Text>
        </Grid.Col>
        <Grid.Col span={9}>{`${order.amount} ${order.unit.unit}`}</Grid.Col>
      </Grid>
    </Accordion>
  );
};

export default AccordionGeneral;
